/* =========================================================================
   HIRA MODA – 10% Abendkleider Hinweis auf der Produktseite
   - Erscheint nur bei Produkten der Kategorie "Abendkleider"
   - Direkt ueber dem "In den Warenkorb"-Button, Handy + Desktop
   - Rein additiv, keine Theme-Dateien veraendert
   ========================================================================= */
(function () {
  if (window.__hmAbendBadge) return;
  window.__hmAbendBadge = true;

  // Handles der Abendkleider-Produkte (Kategorie "Abendkleider")
  var HANDLES = {
    "abendkleid-glitzer": 1,
    "abendkleid-festlich": 1,
    "abendkleid-feminin-besonders-elegant": 1,
    "a74-chiffon-abendkleid-mit-guertel-in-beige": 1,
    "abendkleid-1": 1,
    "a62-abendkleid-mit-schleppe": 1,
    "a63-abendkleid-violette": 1,
    "abendkleid-elegant-festlich": 1,
    "abendkleid-elegant-festlich-1": 1,
    "chiffon-abendkleid": 1,
    "a64-abendkleid-in-gold": 1,
    "abendkleid-in-2-styling-variationen": 1,
    "schimmerndes-abendkleid": 1,
    "abendkleid-mit-leichter-schleppe": 1,
    "abendkleid-ubergrosse": 1,
    "abendkleid": 1,
    "b20-pompoeses-satinkleid-schwarz": 1,
    "schlichtes-abendkleid-grun-elegant-blickdicht": 1,
    "abendkleid-elegantes-kleid-fur-standesamt-nikah": 1,
    "elegantes-maxikleid-ubergrossen-in-smaragdgrun": 1,
    "abendkleid-elegantes-abendkleid": 1,
    "a89-abendkleid": 1,
    "abendkleid-schlicht": 1
  };

  var TAG_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">' +
    '<path d="M20 10V7a1 1 0 0 0-1-1h-7l-9 9 7 7 9-9v-3z"/>' +
    '<circle cx="16.5" cy="9.5" r="1.3" fill="currentColor" stroke="none"/></svg>';

  function currentHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function isAbend() {
    var h = currentHandle();
    return !!(h && HANDLES[h]);
  }

  function makeBadge() {
    var b = document.createElement('div');
    b.className = 'abendkleid-badge';
    b.setAttribute('data-abend-badge', '');
    b.innerHTML =
      '<span class="abendkleid-badge__ico">' + TAG_SVG + '</span>' +
      '<div>' +
      '<div class="abendkleid-badge__title">10 % RABATT AUF DEIN ABENDKLEID</div>' +
      '<div class="abendkleid-badge__text">Du erhältst 10 % Rabatt auf dein ausgewähltes Abendkleid. Der Rabatt wird automatisch im Warenkorb abgezogen.</div>' +
      '</div>';
    return b;
  }

  function place() {
    if (!isAbend()) return true; // keine Abendkleid-Seite -> nichts tun, fertig
    var scope = document.querySelector('.main-product__template')
      || document.querySelector('[id^="MainProduct-"]')
      || document;
    var btn = scope.querySelector('product-form button[name="add"]')
      || scope.querySelector('button[name="add"]')
      || scope.querySelector('.product-form__submit')
      || scope.querySelector('product-form [type="submit"]');
    if (!btn) return false; // Button noch nicht da -> spaeter erneut versuchen

    var anchor = btn.closest('.product-form__buttons') || btn;
    if (anchor.previousElementSibling && anchor.previousElementSibling.hasAttribute &&
        anchor.previousElementSibling.hasAttribute('data-abend-badge')) return true;
    if (document.querySelector('.main-product__template [data-abend-badge], [id^="MainProduct-"] [data-abend-badge]')) return true;

    anchor.parentNode.insertBefore(makeBadge(), anchor);
    return true;
  }

  function run() {
    if (place()) return;
    var tries = 0;
    var iv = setInterval(function () {
      if (place() || ++tries > 30) clearInterval(iv);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 150); });
})();
